import useFetcher from 'app/_utils/data/useFetcher';

import useSWRMutation from 'swr/mutation';

type MarketplaceType = 'aws';

type MarketplaceInputType = {
  type: MarketplaceType;
  customerId: string;
  productId: string;
};

export type CreateOrganizationDTOPayload = {
  region: string;
  organizationAlias?: string;
  marketplace?: MarketplaceInputType;
};

export type CreateOrganizationDTOResponse = {
  data: {
    location: string;
  };
};

export const useCreateOrganization = (): ReturnType<
  typeof useSWRMutation<CreateOrganizationDTOResponse, unknown, string, CreateOrganizationDTOPayload>
> => {
  const { fetcher } = useFetcher();

  return useSWRMutation(`${process.env.ZEUS_API_URL}/v1/tenants`, (url: string, { arg }) =>
    fetcher<CreateOrganizationDTOResponse>(url, { method: 'POST', body: JSON.stringify(arg) }),
  );
};
